import { StyleSheet } from 'react-native';

import { getDesignToken } from 'styles/constants';
import { isWeb } from 'utils/environment';

export const contentStyles = StyleSheet.create({
  content: {
    backgroundColor: getDesignToken('background-pattern'),
    padding: 0,
    ...(isWeb ? { overflowY: 'scroll' as const } : {}),
  },
});
